/* eslint-disable */
import React from "react";
import { UserCodeContextProvider } from "./src/context/UserCodeContext";
import { LocaleContextProvider } from "./src/context/LocaleContext";
import { KnowledgeItemsProvider } from "./src/context/KnowledgeItemsContext";
import ToastProvider from "./src/components/toast/ToastProvider";
import "@fontsource/open-sans";
import "@fontsource/source-serif-pro";

export const wrapRootElement = ({ element }) => {
  return (
    <UserCodeContextProvider>
      <KnowledgeItemsProvider>{element}</KnowledgeItemsProvider>
    </UserCodeContextProvider>
  );
};

// the LayoutContextProvider must be wrapped for each page in order to be able to access the page-specific locale
export const wrapPageElement = ({ element, props }) => {
  const { pageContext } = props;
  // pages within the src/pages folder don't have a locale but a langKey by gatsby-plugin-i18n
  const locale = pageContext.locale || pageContext.langKey || "de";
  return (
    <LocaleContextProvider pageContextLocale={locale}>
      <ToastProvider element={element} />
    </LocaleContextProvider>
  );
};

export const shouldUpdateScroll = ({ routerProps }) => {
  const { location } = routerProps;

  // Check if navigation was triggered with scrollToTop state
  if (location.state?.scrollToTop) {
    return [0, 0]; // Scroll to top (x, y coordinates)
  }

  // Use default Gatsby scroll restoration for all other navigation
  return true;
};
